import './SystemDocumentationCard.css'
import React from 'react'
import CardBody from '../../../components/Card/CardBody';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import DownloadFileButton from './DownloadFileButton';
import DeleteFileButton from './DeleteFileButton';
import ModifyAccessButton from './ModifyAccessButton';
import ReactTable from "react-table";
import { connect } from "react-redux";
import { getSystemFile, deleteSystemFile, getFileAccounts } from "../../stores/actions/dashboardActions";
import DocumentationUpload from '../DocumentationUpload/DocumentationUpload';
import _ from 'lodash';


class SystemDocumentationCardBody extends React.Component {

    state = { confirmationAlert: null, modifyAccessAlert: null };

    restrictedAccessColumns = [
        {
            Header: "",
            accessor: "filename",
            sortable: false,
            width: 250
        },
        {
            Header: "",
            accessor: "download",
            sortable: false,
            width: 80
        }
    ];

    allColumns = [
        {
            Header: "",
            accessor: "filename",
            sortable: false,
            width: 250
        },
        {
            Header: "",
            accessor: "download",
            sortable: false,
            width: 75
        },
        {
            Header: "",
            accessor: "modifyAccess",
            sortable: false,
            width: 80
        },
        {
            Header: "",
            accessor: "delete",
            sortable: false,
            width: 75
        }
        
    ]
    prettyBytes = (num) => {
        const UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        if (Math.abs(num) < 1) return num + ' ' + UNITS[0];
        const exponent = Math.min(Math.floor(Math.log10(num < 0 ? -num : num) / 3), UNITS.length - 1);
        const n = Number(((num < 0 ? -num : num) / 1000 ** exponent).toPrecision(2));
        return (num < 0 ? '-' : '') + n + ' ' + UNITS[exponent];
      };
      
    componentDidMount(): void {
        this.props.getFileAccounts(this.props.system.ID);
    }

    renderFileInfo = (file) => {
        var createdAt = (new Date(file.createdAt.Time)).toLocaleString('sv-SE').replace('T', ' ');
        var fileSize = this.prettyBytes(file.size)
        return (
            <div>
                <div className='file-info'>
                    {file.filename}
                </div>
                <div className='hidden'>
                    {`${createdAt} [${fileSize}]`}
                </div>
            </div>

        );
    }
    modifySystemFileAccess = () => {

    }
    setConfirmationAlert = (alert: any) => {
        this.setState({confirmationAlert: alert});
    };

    setModifyAccessAlert = (alert: any) => {
        this.setState({modifyAccessAlert: alert});
    };

    render() {
        const { files, getSystemFile, deleteSystemFile, filesAccounts, system, account } = this.props;
        
        const canAddRemove = system.accessRightToAssignment !== 'read_only';

        return (
            <CardBody>
                {this.state.confirmationAlert}
                {this.state.modifyAccessAlert}
                <form>
                    <GridContainer style={{ margin: '0 0 0 -15px'}}>
                        <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                            {canAddRemove ?
                            <DocumentationUpload systemId={system.ID}/>
                            : null}
                            {files && files.length && (filesAccounts && filesAccounts.length) ?
                            <div style={{overflowY: 'scroll', height: '400px'}}>
                            <ReactTable
                                style={{marginTop: '15px'}}
                                data={files.map((file, key) => {
                                    var fileAccounts = [];
                                    fileAccounts = _.filter([...filesAccounts], {fileID: file.id})[0]?.accounts;
                                    
                                    return {
                                        filename: this.renderFileInfo(file),
                                        download: <DownloadFileButton
                                            file={file}
                                            getSystemFile={getSystemFile}
                                        />,
                                        modifyAccess: <ModifyAccessButton
                                            file={file}
                                            fileAccounts={fileAccounts}
                                            modifySystemFileAccess={deleteSystemFile}
                                            setModifyAccessAlert={this.setModifyAccessAlert}
                                            systemID={system.ID}
                                        />,
                                        delete: <DeleteFileButton
                                        file={file}
                                        deleteSystemFile={deleteSystemFile}
                                        setConfirmationAlert={this.setConfirmationAlert}
                                        />
                                    };
                                })}
                                filterable={false}
                                columns={canAddRemove? this.allColumns : this.restrictedAccessColumns}
                                page={0}
                                pageSize={20}
                                minRows={0}
                                showPaginationTop={false}
                                showPaginationBottom={false}
                                className={"-striped -highlight"}
                                onPageChange={page => this.setState({page: page})}
                            />
                            </div>
                            : <div style={{height: '400px', padding: '150px', color: 'rgb(153, 153, 153)'}}>{'No files yet'}</div>}
                        </GridItem>
                    </GridContainer>
                </form>
            </CardBody >
        )
    }
}

const mapStateToProps = (state) => {
    return {
      files: state.dashboard.systemFiles,
      system: state.dashboard.system,
      filesAccounts: state.dashboard.filesAccounts,
      account: state.account.account
    };
  };
  
  const actions = {
    getSystemFile,
    deleteSystemFile,
    getFileAccounts,
  };
  
export default connect(mapStateToProps, actions)(SystemDocumentationCardBody);
